import { Stroke } from './stroke.js';
import * as glMatrix from '../../../../node_modules/gl-matrix/esm';

export class StampStroke extends Stroke {
    _stampPoints;
    _renderedPoint: number;

    constructor(gl, width, height) {
        super(gl, width, height);
        var self = this;
        self._program = 'stampStroke';
        self._stampPoints = [];
        self._accumulate = false;
    }

    setUniforms(program) {
        var self = this;
        super.setUniforms(program);
        self._gl.uniform2fv(program.uniformLocation('stamp_position'), self.stampPoint);
    }

    destroy() {
        var self = this;
        if (self._mask) {
            self._stampPoints = [];
        }
        super.destroy();
    }

    reset() {
        var self = this;
        self._accumulate = false;
        super.reset();
    }

    store() {
        super.store();
        this._accumulate = true;
    }

    setStampPoint(point) {
        var self = this;
        self._stampPoints = [];
        self._stampPoints.push(point);
        self._points = [];
        self._renderedPoint = 0;
    }

    addPoint(point, size) {
        var self = this;
        if (self._stampPoints.length === 0) {
            return false;
        }

        const result = super.addPoint(point, size);
        if (result) {
            var direction = glMatrix.vec2.create();
            glMatrix.vec2.subtract(direction, self._points[self._points.length - 1], self._points[self._points.length - 2]);
            var newStampPoint = glMatrix.vec2.clone(self._stampPoints[self._stampPoints.length - 1]);
            glMatrix.vec2.add(newStampPoint, newStampPoint, direction);
            self._stampPoints.push(newStampPoint);
            glMatrix.vec2.subtract(direction, self._stampPoints[self._stampPoints.length - 1], self._stampPoints[this._stampPoints.length - 2]);
        }
        return result;
    }

    get stampPoint() {
        var self = this;
        return self._stampPoints[self._currentPoint];
    }

}